import type { IconSvgObject } from './types';

const QuoteDownCircleIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 12V9C10.5 8.44772 10.0523 8 9.5 8H7.5C6.94772 8 6.5 8.44772 6.5 9V11C6.5 11.5523 6.94772 12 7.5 12H10.5ZM10.5 12V13C10.5 14.6569 9.15685 16 7.5 16M17.5 12V9C17.5 8.44772 17.0523 8 16.5 8H14.5C13.9477 8 13.5 8.44772 13.5 9V11C13.5 11.5523 13.9477 12 14.5 12H17.5ZM17.5 12V13C17.5 14.6569 16.1569 16 14.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default QuoteDownCircleIcon;
